import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ILoanData } from '@app/models/loan-data.model';
import { LoanType } from '@app/models/Loan-Type';
import { IVehicle } from '@app/models/vehicle.model';
import {
  BUNDLES_EP,
  PROPOSALS_EP,
  RATES_EP,
  RERATING_EP
} from '@app/shared/constants/globalConstants';
import { Observable } from 'rxjs';

@Injectable()
export class LoanTypeInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // This applies for endpoints that have `/rates` or `/proposals` or `/bundles` or `/rerating` in them
    if (!req.body || typeof req.body !== 'object') return next.handle(req);

    const url = req.url.toLowerCase();
    const isTargetEndPoint =
      url.includes(RATES_EP) ||
      url.includes(PROPOSALS_EP) ||
      url.includes(BUNDLES_EP) ||
      url.includes(RERATING_EP);

    if (!isTargetEndPoint) return next.handle(req);

    const hasLoanData = 'loanData' in req.body;
    const hasVehicle = 'vehicle' in req.body;

    let modifiedBody = req.body;
    const loanData = modifiedBody?.loanData as ILoanData;
    const vehicle = modifiedBody?.vehicle as IVehicle;

    if (
      hasLoanData &&
      hasVehicle &&
      !this.isValidLoanType(loanData?.loanType)
    ) {
      modifiedBody = this.applyLoanType(modifiedBody);
    }

    if (hasVehicle && !this.isValidVehicleYear(vehicle?.year)) {
      modifiedBody = this.formatVehicleYear(modifiedBody);
    }

    return next.handle(req.clone({ body: modifiedBody }));
  }

  /**
   * Checks if loanType is a valid, usable LoanType enum value.
   * LoanType.None (0) is not considered valid for API requests.
   */
  private isValidLoanType(loanType: any): boolean {
    return (
      typeof loanType === 'number' &&
      !isNaN(loanType) &&
      (loanType === LoanType.Vehicle ||
        loanType === LoanType.Consumer ||
        loanType === LoanType.OtherCollateral ||
        loanType === LoanType.RoadSideCoverage)
    );
  }

  private isValidVehicleYear(vehicleYear: any): boolean {
    return typeof vehicleYear === 'number' && !isNaN(vehicleYear);
  }

  private applyLoanType(requestBody: any): any {
    const collateralType = requestBody?.vehicle?.collateralType;

    return {
      ...requestBody,
      loanData: {
        ...requestBody.loanData,
        loanType:
          collateralType != null && collateralType > 0
            ? LoanType.OtherCollateral
            : LoanType.Vehicle
      }
    };
  }

  private formatVehicleYear(requestBody: any): any {
    const year = Number(requestBody?.vehicle?.year);

    return {
      ...requestBody,
      vehicle: {
        ...requestBody.vehicle,
        year: !isNaN(year) ? year : 0
      }
    };
  }
}
